// Shared with ContactUsPage and PartySuggestCategoryDrawer.

const SPAM_PATTERNS = [
  /(?:https?:\/\/|www\.)/i,
  /(?:buy|sell|cheap|discount|free|offer|deal|price|cost)/i,
  /(?:click here|visit now|act now|limited time)/i,
  /(?:viagra|cialis|casino|poker|lottery|winner)/i,
  /(?:make money|earn money|work from home|get rich)/i,
  /(?:congratulations|you won|prize|claim)/i,
  /(?:replica|rolex|nike|gucci|louis vuitton)/i,
  /(?:loan|credit|debt|mortgage)/i,
];

export function isSpamMessage(message: string): boolean {
  const lowerMessage = message.toLowerCase();
  const words = lowerMessage.split(/\s+/);
  const wordCounts: Record<string, number> = {};
  for (const word of words) {
    wordCounts[word] = (wordCounts[word] || 0) + 1;
    if (wordCounts[word] > 5) {
      return true;
    }
  }
  for (const pattern of SPAM_PATTERNS) {
    if (pattern.test(message)) {
      return true;
    }
  }
  const upperCaseCount = (message.match(/[A-Z]/g) || []).length;
  if (upperCaseCount > message.length * 0.5 && message.length > 20) {
    return true;
  }
  return false;
}
